/**
 * Gateway may redirect to app `/` with session cookie only (no ?token= on app callback).
 * See fetchSessionByGatewayCookie in authSession.api.ts.
 */
export const GATEWAY_COOKIE_SESSION_KEY = "variphi_gateway_cookie_session";

export function markGatewayCookieSession(): void {
  try {
    sessionStorage.setItem(GATEWAY_COOKIE_SESSION_KEY, "1");
  } catch {
    // ignore
  }
}

export function isGatewayCookieSessionActive(): boolean {
  try {
    return sessionStorage.getItem(GATEWAY_COOKIE_SESSION_KEY) === "1";
  } catch {
    return false;
  }
}

export function clearGatewayCookieSession(): void {
  try {
    sessionStorage.removeItem(GATEWAY_COOKIE_SESSION_KEY);
  } catch {
    // ignore
  }
}
